import React from 'react';
import { IFetchStatus } from '../../../../types/rest/IFetchStatus';
import { IStandardDocumentData, IStandardDocumentVersionData } from 'types/order/documents/shared/interfaces';
import { BoldBodyText, Grid, SmallBodyText, Button, SpacerRow } from 'ui-toolkit';
import { IUserData } from 'types/users/IUser';
import { getUserName } from 'utilities/users/getUserName';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { NoGapGrid } from 'components/shared/NoGapGrid';
import { downloadDocument } from 'API/order/documents/downloadDocument';
import { DateFormat, getDateString } from '../../../../ui-toolkit/utilities/getDateString';

interface IDocumentHistoryContainer {
  document: IStandardDocumentData | null;
  documentsHistoryFetchStatus: IFetchStatus;
  documentHistory: {
    [documentId: string]: IStandardDocumentVersionData[];
  };
  users: IUserData[];
  onBackClick: () => void;
  setPreviewDoc: (val: IStandardDocumentVersionData | null) => void;
  isZillowClosingEnabled: boolean;
}

export const DocumentHistory: React.FC<IDocumentHistoryContainer> = ({
  document,
  documentsHistoryFetchStatus,
  documentHistory,
  users,
  onBackClick,
  setPreviewDoc,
  isZillowClosingEnabled,
}) => {
  return (
    <>
      <BoldBodyText>
        <Button intent={'ghost'} onClick={() => onBackClick()}>
          <FontAwesomeIcon icon={faArrowLeft} />
        </Button>
        Version History
      </BoldBodyText>
      <SpacerRow />
      <Grid templateColumns={'1fr 0.35fr'}>
        {document?.id &&
          documentsHistoryFetchStatus.success &&
          documentHistory[document.id].map((v) => {
            return (
              <>
                <Grid textAlign={'left'} key={v.id}>
                  <SmallBodyText intent={'faded'}>
                    {getDateString(DateFormat.shortDateTime, v.fileUpdatedAt, false)} by
                    {getUserName(users, isZillowClosingEnabled, v.uploaderType, v.uploaderId)}
                  </SmallBodyText>
                </Grid>
                <Grid>
                  <NoGapGrid>
                    <Button intent={'ghost'} isInline onClick={() => setPreviewDoc(v)}>
                      Preview
                    </Button>
                    <Button intent={'ghost'} isInline onClick={() => downloadDocument(v.id, v.versionId, v.fileName)}>
                      Download
                    </Button>
                  </NoGapGrid>
                  {/* waiting to here from product about desired delete functionality */}
                  {/* <Button intent={'danger'} appearance={'minimal'} onClick={() => setDeleteDocument(v)}>
                    <FontAwesomeIcon icon={faTrashCan} />
                  </Button> */}
                </Grid>
              </>
            );
          })}
      </Grid>
    </>
  );
};
